<template>
  <div class="page-content--body">
    <div class="page-content--body-right construction-page">
      <div class="construction-page--img"><img alt="" src="@/assets/images/construction-img.png" /></div>
      <div class="construction-page--title">Страница находится в&nbsp;стадии разработки</div>
      <div class="construction-page--text">
        Извините, страница находится в стадии разработки. В самое ближайшее время здесь появится детальная информация, заходите сюда позже.<br>
        Перейдите на <router-link to="/dashboard">главную страницу</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'technicalPage',
  data() {
    return {
    };
  },
  mounted() {
    this.$store.dispatch('SetTitle', 'Разработка');
  },
};
</script>

<style lang="scss">
.construction-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: space-around;
  height: calc(100vh - 200px);
  @media (max-width: 1024px) {
    height: calc(100vh - 230px);
  }
  &--title {
    font-size: 3vw;
    line-height: 1;
    margin-bottom: 20px;
    @media (max-width: 767px) {
      font-size: 24px!important;
    }
  }
  &--subtitle {

  }
}
</style>
